export default __webpack_public_path__ + "static/media/McGillBioDesign.9ab864d9.jpg";